<div *ngIf="canAccess">
  <h2 class="!mt-0">
    {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.TITLE' | translate }}

    {{ !name || name == ' ' || name == undefined ? user.attributes?.['phone_number'] : name + ' ' + middle_name }}
  </h2>

  <form [formGroup]="createForm">

    <!-- Estructura dinámica basada en isMobile -->
    <div *ngIf="!isMobile" class="grid grid-cols-2 gap-4">
      <!-- Campos para pantallas más grandes (dos columnas) -->

      <!-- Nombre -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}
        </mat-label>
        <input formControlName="name"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}" />
      </mat-form-field>

      <!-- Apellido -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}
        </mat-label>
        <input formControlName="middle_name"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}" />
      </mat-form-field>

      <!-- Dirección -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ADDRESS' | translate }}
        </mat-label>
        <input formControlName="custom:address"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ADDRESS' | translate }}" />
      </mat-form-field>

      <!-- Ciudad -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.CITY' | translate }}
        </mat-label>
        <input formControlName="custom:ciudad"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.CITY' | translate }}" />
      </mat-form-field>

      <!-- Provincia -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PROVINCE' | translate }}
        </mat-label>
        <input formControlName="custom:provincia"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PROVINCE' | translate }}" />
      </mat-form-field>

      <!-- Código Postal -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}
        </mat-label>
        <input formControlName="custom:postcode"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}" />
      </mat-form-field>

      <!-- País -->
      <!-- <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}
        </mat-label>
        <input formControlName="custom:country"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}" />
      </mat-form-field> -->


      <mat-form-field appearance="fill" *ngIf="countriesNames$ | async as countriesNames">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COUNTRY' | translate }}
        </mat-label>
        <mat-select
          formControlName="custom:country"
          [(value)]="selectedCountry"
          #countrySelect
        >
          <mat-option>
            <input
              matInput
              type="text"
              placeholder="Search country"
              [(ngModel)]="countryFilter"
              [ngModelOptions]="{ standalone: true }"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            />
          </mat-option>

          <mat-option
            *ngFor="let country of filteredCountries(countries, countriesNames, countryFilter)"
            [value]="country"
          >
            <span style="display: inline-flex; align-items: center;">
              <img
                [src]="country | tuiFlag"
                width="20"
                height="14"
                style="margin-right: 8px;"
              />
              {{ countriesNames[country] }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>


      <!-- ID -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ID' | translate }}
        </mat-label>
        <input formControlName="custom:passport"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ID' | translate }}" />
      </mat-form-field>

      <!-- Correo Electrónico -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.EMAIL' | translate }}
        </mat-label>
        <input type="email"
               formControlName="email"
               matInput
               placeholder="example@example.com" />
      </mat-form-field>

      <!-- Teléfono -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.PHONE' | translate }}
        </mat-label>
        <input type="tel"
               formControlName="phone_number"
               matInput
               placeholder="+34555555123" />
      </mat-form-field>

      <!-- Método de liquidación de comisiones -->
  <!--    <mat-form-field appearance="fill">-->
  <!--      <mat-label>-->
  <!--        {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.COMMISSION_PAYMENT_TYPE' | translate }}-->
  <!--      </mat-label>-->
  <!--      <mat-select-->
  <!--        formControlName="commissionPaymentType"-->
  <!--        [(value)]="commissionPaymentType"-->
  <!--      >-->
  <!--        <mat-option-->
  <!--          *ngFor="let method of Object.keys(paymentTypes)"-->
  <!--          [value]="method"-->
  <!--        >-->
  <!--          <span style="display: inline-flex; align-items: center;">-->
  <!--            {{ paymentTypes[method] }}-->
  <!--          </span>-->
  <!--        </mat-option>-->
  <!--      </mat-select>-->
  <!--    </mat-form-field>-->


      <!-- Cuenta bancaria -->
      <mat-form-field class="w-full">
        <mat-label>
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.BANK_ACCOUNT' | translate }}
        </mat-label>
        <input formControlName="bankAccount"
               type="text"
               matInput
               placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.BANK_ACCOUNT' | translate }}" />
      </mat-form-field>

    </div>

    <div *ngIf="isMobile" class="flex flex-col gap-4">
      <!-- Campos para pantallas pequeñas (una columna) -->

      <mat-form-field class="w-full" *ngFor="let field of [
        { label: 'NAME', control: 'name' },
        { label: 'SURNAME', control: 'middle_name' },
        { label: 'ADDRESS', control: 'custom:address' },
        { label: 'CITY', control: 'custom:ciudad' },
        { label: 'PROVINCE', control: 'custom:provincia' },
        { label: 'ZIPCODE', control: 'custom:postcode' },
        { label: 'COUNTRY', control: 'custom:country' },
        { label: 'ID', control: 'custom:passport' },
        { label: 'EMAIL', control: 'email' },
        { label: 'PHONE', control: 'phone_number' },
        { label: 'BANK_ACCOUNT', control: 'bankAccount' }
      ]">
        <mat-label>
          {{ ('COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.' + field.label) | translate }}
        </mat-label>
        <input [formControlName]="field.control" matInput />
      </mat-form-field>

    </div>

     <!-- Botones -->
    <div class="flex justify-between gap-4 mt-12">
      <app-button expand="full" color="secondary" (click)="goBack()">
        {{ 'COMMON.CANCEL' | translate }}
      </app-button>
      <app-button expand="full" (click)="onUpdate()">
        {{ 'COMMON.CONFIRM' | translate }}
      </app-button>
    </div>

  </form>
</div>

<style>
  .grid {
  display: grid;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.gap-4 {
  gap: 16px;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.w-full {
  width: 100%;
}
</style>
